import { render, staticRenderFns } from "./ChildrenCourseContent.vue?vue&type=template&id=52ff1736&scoped=true"
import script from "./ChildrenCourseContent.vue?vue&type=script&lang=js"
export * from "./ChildrenCourseContent.vue?vue&type=script&lang=js"
import style0 from "./ChildrenCourseContent.vue?vue&type=style&index=0&id=52ff1736&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ff1736",
  null
  
)

export default component.exports